module.exports = "<div class=\"$actorWrapper actor-wrapper centered\">\n  <img src=\"{{embeddedImgRoot}}img/circle.png\">\n</div>\n"